import EventsDispatcher from 'controllers/EventsDispatcher';


const events = Object.freeze({
    request: "request",
    response: "response"
});

class APICaller extends EventsDispatcher
{

    constructor(apiUrl = "https://rayman.pixels-hub.com/v1/api/")
    {
        super();

        this.token = "";
        this.apiUrl = apiUrl;
    }

    static get events()
    {
        return events;
    }

    Get(path, queryParams = {}, abortSignal = null)
    {
        let url = createUrl(this.apiUrl, path, queryParams);
        this.dispatch(APICaller.events.request, {method: "GET", path: path, queryParams: queryParams});
        return fetch(url, {
            method: 'GET',            
            headers:{
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+this.token
            },
            signal: abortSignal
        }).then((response) =>
        {
            this.dispatch(APICaller.events.response, {method: "GET", path: path, queryParams: queryParams, response: response});
            if(response.ok)
            {
                return response;
            }
            else
            {
                console.log(`Error on request [${url}]: Error ${response.status}, ${response.statusText}`);
                return response;
            }
        })
        .catch((error) => console.log(error));
    }

    Post(path, requestbody, queryParams = {}, method = "POST", abortSignal = null)
    {
        let url = createUrl(this.apiUrl, path, queryParams);
        this.dispatch(APICaller.events.request, {method: method, path: path, queryParams: queryParams, requestBody: requestbody});
        return fetch(url, {
            method: method, // or 'PUT'
            body: JSON.stringify(requestbody), // data can be `string` or {object}!
            headers:{
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+this.token
            },
            signal: abortSignal
        }).then((response) =>
        {
            this.dispatch(APICaller.events.response, {method: method, path: path, queryParams: queryParams, response: response});
            if(!response.ok) console.log(`Error on request [${url}]: Error ${response.status}, ${response.statusText}`);
            return response;
        })
        .catch((error) => console.log(error));
    }

    PostForm(path, requestbody, queryParams = {}, abortSignal = null)
    {
        let url = createUrl(this.apiUrl, path, queryParams);
        this.dispatch(APICaller.events.request, {method: "POST", path: path, queryParams: queryParams, requestBody: requestbody});
        return fetch(url, {
            method: "POST", // or 'PUT'
            body: requestbody, // data can be `string` or {object}!
            headers:{
              //'Content-Type': 'multipart/form-data',
              'Authorization': 'Bearer '+this.token
            },
            signal: abortSignal
        }).then((response) =>
        {
            this.dispatch(APICaller.events.response, {method: "POST", path: path, queryParams: queryParams, response: response});
            if(!response.ok) console.log(`Error on request [${url}]: Error ${response.status}, ${response.statusText}`);
            return response;
        })
        .catch((error) => console.log(error));
    }

    Put(path, requestbody, queryParams = {}, abortSignal = null)
    {
        return this.Post(path, requestbody, queryParams, "PUT", abortSignal);
    }

    Patch(path, requestbody, queryParams = {}, abortSignal = null)
    {
        return this.Post(path, requestbody, queryParams, "PATCH", abortSignal);
    }

    Delete(path, queryParams, abortSignal = null)
    {
        let url = createUrl(this.apiUrl, path, queryParams);
        this.dispatch(APICaller.events.request, {method: "DELETE", path: path, queryParams: queryParams});
        return fetch(url, {
            method: 'DELETE',            
            headers:{
              'Authorization': 'Bearer '+this.token
            },
            signal: abortSignal
        }).then((response) =>
        {
            this.dispatch(APICaller.events.response, {method: "DELETE", path: path, queryParams: queryParams, response: response});
            if(!response.ok) console.log(`Error on request [${url}]: Error ${response.status}, ${response.statusText}`);
            return response;
        })
        .catch((error) => console.log(error));
    }

    Login(path, requestbody, queryParams = {})
    {
        let url = createUrl(this.apiUrl, path, queryParams);
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(requestbody),
            credentials: 'include',
            headers:{
              'Content-Type': 'application/json'
            }
        }).then(async (response) =>
        {
            if(response.ok)
            {
                let login = await response.json();
                this.token = login.token;
                return login;
            }
            else
            {
                console.log(`Error on request [${url}]: Error ${response.status}, ${response.statusText}`);
                return null;
            }
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    }

    GetApiURL(path, queryParams = {})
    {
        if(!Array.isArray(path)) path = [path];
        return createUrl(this.apiUrl, path, queryParams);
    }

    async GetAuthenticatedURL(path, queryParams = {})
    {
        let response = await fetch(this.GetApiURL(path, queryParams), {
            headers: {
                'Authorization': 'Bearer '+this.token
            } 
        })
        return URL.createObjectURL(await response.blob());
    }
}

function createUrl(base, path, queryParams = {})
{
    if(Array.isArray(path)) path = combinePaths(path);
    let url = new URL(combinePaths([base,path]));
    url.search = buildParams(queryParams);
    return url.href;
}

function buildParams(data) {
    const params = new URLSearchParams();
  
    Object.keys(data).forEach((key) => {
      if (Array.isArray(data[key])) {
        data[key].forEach(item => params.append(key, item));
      } else {
        params.append(key, data[key]);
      }
    });
  
    return params;
  };

function combinePaths(pathParts)
{
    let result = "";
    if(Array.isArray(pathParts))
    {
        for(let i=0;i<pathParts.length;i++)
        {
            
            if(pathParts[i] === null || pathParts[i] === undefined)
            {
                console.warn("an API path part is giving an invalid value");
                pathParts[i] = "null";
            }
            else pathParts[i] = pathParts[i].toString();
            if(pathParts[i].startsWith("/")) pathParts[i] = pathParts[i].substring(1,pathParts[i].length);
            if(pathParts[i].endsWith("/")) pathParts[i] = pathParts[i].substring(0,pathParts[i].length - 1);
            if(i > 0) result = result.concat("/",pathParts[i]);
            else result = pathParts[i];
        }

        return result;
    }
    else return pathParts;
}

export let api = new APICaller();
export default APICaller;
export {combinePaths};